import React from "react";
import { NavLink } from "react-router-dom";
import {
  TenantSVG,
  UserSVG,
  UsersSVG,
  SProviderSVG,
  LockSVG,
} from "assets/images";
import { AppPath, UserRole, UserType } from "utils/constants";
import { JA } from "utils/strings.ja";
import { hasPermission } from "utils";
// import { formatDateJsFromTimeStamp } from "utils";

const listUserType = Object.values(UserType);

const menuItem = ({ role, path, icon, label }) => {
  return (
    <li key={label}>
      <NavLink
        to={path}
        className={({ isActive, isPending }) => {
          return `group relative flex items-center gap-2.5
                    rounded-md px-4 py-2 font-medium whitespace-nowrap text-bodydark1 duration-300
                    ease-in-out hover:bg-graydark dark:hover:bg-meta-4 
                    ${isActive ? "bg-graydark dark:bg-meta-4" : ""}`;
        }}
      >
        {/* {icon} */}
        {label}
      </NavLink>
    </li>
  );
};

const menus = [
  {
    label: JA.provider.management,
    userType: [UserType.NTTsp, UserType.ServiceProvider],
    path: AppPath.ServiceProvider,
    icon: <SProviderSVG />,
  },
  {
    label: JA.provider.userManagement,
    userType: [UserType.NTTsp, UserType.ServiceProvider],
    path: AppPath.UserSP,
    icon: <UsersSVG />,
  },
  {
    label: JA.tenant.groupManagement,
    // userType: [UserType.NTTsp, UserType.ServiceProvider],
    checkPermission: (loginData) => {
      if ([UserType.NTTsp, UserType.ServiceProvider, UserType.Tenant].includes(loginData.type)) return true;
      // if (loginData.type == UserType.Tenant && loginData.role == UserRole.Admin) return true;
      return false;
    },
    path: AppPath.TenantManagement,
    icon: <TenantSVG />,
  },
  {
    label: JA.tenant.userManagement,
    checkPermission: (loginData) => loginData.type != UserType.Location,
    path: AppPath.UserManagement,
    icon: <UserSVG />,
  },
  {
    label: JA.location.management,
    userType: listUserType,
    // checkPermission: (loginData) => {
    //   if ([UserType.NTTsp, UserType.ServiceProvider, UserType.Tenant].includes(loginData.type)) return true;
    //   if (loginData.role == UserRole.Admin) return true;
    //   return false;
    // },
    path: AppPath.Location,
    icon: <UserSVG />,
  },
  {
    label: JA.location.userManagement,
    checkPermission: () => true,
    // checkPermission: (loginData) => !hasPermission(loginData, UserRole.User, UserType.Location),
    path: AppPath.LocationUser,
    icon: <UserSVG />,
  },
  {
    label: JA.camera.management,
    userType: listUserType,
    path: AppPath.CameraManagement,
    icon: <LockSVG />,
  },
];

const Sidebar = ({ loginData, sidebarToggle, handleSidebarToggle }) => {
  const menuItems = menus.map((menu) => {
    if (
      (menu?.checkPermission && menu?.checkPermission(loginData)) ||
      (menu.userType && menu.userType?.includes(loginData.type))
    ) {
      return menuItem(menu);
    }
    return null;
  });
  return (
    <aside
      className={`
        z-99 flex h-screen w-max min-w-48
        flex-col overflow-y-hidden bg-black duration-300
        ease-linear dark:bg-boxdark lg:flex lg:translate-x-0
        ${sidebarToggle ? "" : "md:hidden sm:hidden"}
        ${sidebarToggle ? "translate-x-0" : "-translate-x-full"}
        `}
    >
      {/* SIDEBAR HEADER */}
      <div className="flex items-center justify-between gap-2 px-6 py-5.5 lg:py-6.5">
        <div>
          <a href="/">
            <div>
              <p className="font-semibold leading-relaxed text-white text-title-md2">
                {JA.nav.behaviourAi}
              </p>
            </div>
          </a>
          {/* {loginData.last_login && (
            <p>最終ログイン: {formatDateJsFromTimeStamp(loginData.last_login)}</p>
          )} */}
        </div>

        <button className="hidden lg:hidden" onClick={handleSidebarToggle}>
          <svg
            className="fill-current"
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 8.175H2.98748L9.36248 1.6875C9.69998 1.35 9.69998 0.825 9.36248 0.4875C9.02498 0.15 8.49998 0.15 8.16248 0.4875L0.399976 8.3625C0.0624756 8.7 0.0624756 9.225 0.399976 9.5625L8.16248 17.4375C8.31248 17.5875 8.53748 17.7 8.76248 17.7C8.98748 17.7 9.17498 17.625 9.36248 17.475C9.69998 17.1375 9.69998 16.6125 9.36248 16.275L3.02498 9.8625H19C19.45 9.8625 19.825 9.4875 19.825 9.0375C19.825 8.55 19.45 8.175 19 8.175Z"
              fill=""
            />
          </svg>
        </button>
      </div>
      {/* SIDEBAR HEADER */}

      <div className="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar">
        <nav className="px-3 py-4 lg:px-4">
          <div>
            <ul className="mb-6 flex flex-col gap-1.5">{menuItems}</ul>
          </div>
        </nav>
      </div>
    </aside>
  );
};
export default Sidebar;
